module.exports = __webpack_public_path__ + "static/media/refresh.f2be110c.svg";